import Cookies from 'universal-cookie';
const storagePrefix = 'csrf';

const cookies = new Cookies();

const storage = {
	getCookie: () => {
		return cookies.get(`${storagePrefix}token`);
	},

	getRegistrationData: () => {
		return sessionStorage.getItem('registrationData');
	},

	clearRegistrationData: () => {
		return sessionStorage.removeItem('registrationData');
	},
};

export default storage;
